/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketAdmission } from './TicketAdmission';
import {
    TicketAdmissionFromJSON,
    TicketAdmissionFromJSONTyped,
    TicketAdmissionToJSON,
    TicketAdmissionToJSONTyped,
} from './TicketAdmission';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfTicketAdmission
 */
export interface ResultOfIReadOnlyListOfTicketAdmission {
    /**
     * 
     * @type {Array<TicketAdmission>}
     * @memberof ResultOfIReadOnlyListOfTicketAdmission
     */
    data: Array<TicketAdmission> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfTicketAdmission
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfTicketAdmission
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfTicketAdmission interface.
 */
export function instanceOfResultOfIReadOnlyListOfTicketAdmission(value: object): value is ResultOfIReadOnlyListOfTicketAdmission {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfTicketAdmissionFromJSON(json: any): ResultOfIReadOnlyListOfTicketAdmission {
    return ResultOfIReadOnlyListOfTicketAdmissionFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfTicketAdmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfTicketAdmission {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(TicketAdmissionFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfTicketAdmissionToJSON(json: any): ResultOfIReadOnlyListOfTicketAdmission {
    return ResultOfIReadOnlyListOfTicketAdmissionToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfTicketAdmissionToJSONTyped(value?: ResultOfIReadOnlyListOfTicketAdmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(TicketAdmissionToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

